import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import UiSwitch from "../PageLayout/UiSwitch";
import {
  featuresSetupSetContentType,
  featuresSetupUpdateFeatures,
  setFeaturesSetupTogglePopupOpened
} from "./featuresActions";
import {getFeatureEditPermission, getFilteredFeatures} from "./featuresFunctions";
import SvgIcons from "../Icons/SvgIcons";
import FeaturesSetupTopPanelCurrencySelect from "./FeaturesSetupTopPanelCurrencySelect";
import {FEATURES_CONTENT_TYPES} from "./featuresReducer";
import { AccessRights, PARTS } from '../../schemas/accessRightsModel';
import FeaturesSetupTopPanelDeleteFeatures from './FeaturesSetupTopPanelDeleteFeatures';
import FeaturesSetupTopPanelSharedFeatureNameToggle from './FeaturesSetupTopPanelSharedFeatureNameToggle';


const FeaturesSetupTopPanelCenter = (props) => {

  const {featuresSetupUpdateFeatures, featuresListReceived, selectedFeatures, setFeaturesSetupTogglePopupOpened,
    featuresContentType, featuresSetupSetContentType, useDifferentCurrencies, enablePermission, deleteFeaturesEnabled, sharedFeatureNameEdit} = props;

  const allUnlocked = featuresListReceived && selectedFeatures.length && selectedFeatures.every(wizardItem => wizardItem.unlocked);
  const allLocked = featuresListReceived && selectedFeatures.length && selectedFeatures.every(wizardItem => !wizardItem.unlocked);

  const showEnabledModal = () => {
    setFeaturesSetupTogglePopupOpened(true);
  }

  const changeLockedClick = (unlocked) => {
    featuresSetupUpdateFeatures("unlocked", unlocked)
  }

  const showToolSettingsType = featuresContentType === FEATURES_CONTENT_TYPES.toolSettingsType;
  const showConstAndShippingType = featuresContentType === FEATURES_CONTENT_TYPES.costAndShippingType;
  return (
    <div className="fs-top__item fs-top__item--center">
      <div className="en-group text-center">
        <div className="en-group__title">
          <FormattedMessage id="features.setup.top.enabledTools"/>
        </div>
        <div className="en-group__buttons flex flex--center">
          <div className="en-panel en-panel--round en-panel--bordered">
            <button className="en-panel__button" onClick={showEnabledModal}>
              {SvgIcons.toggle}
            </button>
          </div>
          <UiSwitch onClick={() => {
            return featuresSetupSetContentType(showToolSettingsType ? FEATURES_CONTENT_TYPES.default : FEATURES_CONTENT_TYPES.toolSettingsType)
          }}
                    textId={showToolSettingsType ? "wizard.groups.disableSelected" : "wizard.groups.enableSelected"}
                    checked={showToolSettingsType}/>
        </div>
      </div>
      <div className="en-group text-center">
        <div className="en-group__title">
          <FormattedMessage id="features.setup.top.lockAll"/>
        </div>
        <div className="en-group__buttons">
          <div className="en-panel en-panel--bordered">
            <button className={"en-panel__button en-panel__button--unlock" + (allUnlocked ? " on2" : "")}
                    onClick={() => changeLockedClick(true)} title="Unlock all features"/>
            <button className={"en-panel__button en-panel__button--lock" + (allLocked ? " on" : "")}
                    onClick={() => changeLockedClick(false)} title="Lock all features"/>
          </div>
        </div>
      </div>
      <div className="en-group text-center">
        <div className="en-group__title">
          <FormattedMessage id="features.setup.top.costAndShipping"/>
        </div>
        {enablePermission.visible ? (
          <div className="en-group__buttons">
            <UiSwitch onClick={() => {
              return featuresSetupSetContentType(showConstAndShippingType ? FEATURES_CONTENT_TYPES.default : FEATURES_CONTENT_TYPES.costAndShippingType)
            }}
                      textId={showConstAndShippingType ? "wizard.groups.disableSelected" : "wizard.groups.enableSelected"}
                      checked={showConstAndShippingType}/>
          </div>
        ) : null}
      </div>
      {useDifferentCurrencies ? (
        <FeaturesSetupTopPanelCurrencySelect/>
      ) : null}
      {deleteFeaturesEnabled ? (
        <FeaturesSetupTopPanelDeleteFeatures/>
      ) : null}
      {sharedFeatureNameEdit ? (
        <FeaturesSetupTopPanelSharedFeatureNameToggle/>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {featuresListReceived, featuresContentType} = store.featuresSetupState;
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesOnly = getFilteredFeatures(store, true, true);
  const selectedFeatures = selectedFeaturesOnly.length ? selectedFeaturesOnly : featuresList;
  const {customerInfo} = store.newaccount;
  const {enablePermission} = getFeatureEditPermission(store);
  const AR = AccessRights.get(store);

  return {
    selectedFeatures,
    featuresListReceived,
    featuresContentType,
    useDifferentCurrencies: customerInfo.useDifferentCurrencies,
    enablePermission,
    deleteFeaturesEnabled: AR.isSiteAdmin(true), // || AR.checkRightsAdminRestricted(PARTS.PROJECT_SCOPE_DELETE_FEATURES).visible,
    sharedFeatureNameEdit: AR.isSiteAdmin(true),
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeatures,
  setFeaturesSetupTogglePopupOpened,
  featuresSetupSetContentType,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupTopPanelCenter)
